export default [
  {
    path: "/rmcProdFarmGroup",
    component: () => import("@/components/page/RMC/Produce/farmGroup/query"),
    meta: { title: "Farm Group维护" },
  },
  {
    path: "/rmcProdFarmGroup/detail",
    component: () => import("@/components/page/RMC/Produce/farmGroup/detail"),
    meta: { title: "Farm Group详情" },
  },
  {
    path: "/rmcProdScore",
    component: () => import("@/components/page/RMC/Produce/rmcProScore/query"),
    meta: { title: "RMC评分" },
  },
  {
    path: "/rmcProdScore/detail",
    component: () => import("@/components/page/RMC/Produce/rmcProScore/detail"),
    meta: { title: "RMC评分详情" },
  },
  {
    path: "/rmcProdPcQty",
    name:"rmcProdPurchase",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProPurchaseQty/query"),
    meta: { title: "采购量" },
  },
  {
    path: "/rmcProdPcQty/detail",
    name:"rmcProdPurchaseDetail",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProPurchaseQty/detail"),
    meta: { title: "采购量详情" },
  },
  {
    path: "/rmcProdFarm",
    name: "rmcProdFarm",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProFarmList/query"),
    meta: { title: "农场清单" },
  },
  {
    path: "/rmcProdFarm/detail",
    name: "rmcProdFarmDetail",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProFarmList/detail"),
    meta: { title: "农场清单详情" },
  },
  {
    path: "/rmcProdFarm/auditDetail",
    name: "rmcProtFarmAuditDetail",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProFarmList/auditDetail"),
    meta: { title: "农场清单详情维护" },
  },
  {
    path: "/rmcProdAuditor",
    name:"rmcProdAudit",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProAuditorList/query"),
    meta: { title: "审核员清单" },
  },
  {
    path: "/rmcProdAuditor/detail",
    name:"rmcProdAuditDetail",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProAuditorList/detail"),
    meta: { title: "审核员清单详情" },
  },
  // 药品清单
  {
    path: "/rmcProdMedicine",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProDrugList/query"),
    meta: { title: "药品清单" },
  },
  // 药品清单历史
  {
    path: "/proDrugHistory",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProDrugList/drugHistory"),
    meta: { title: "药品清单历史" },
  },
  {
    path: "/rmcProdMedicine/detail",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProDrugList/detail"),
    meta: { title: "药品清单详情" },
  },
  // 药品用量
  {
    path: "/rmcProdMedUsage",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProDrugDosage/query"),
    meta: { title: "药品用量" },
  },
  {
    path: "/rmcProdMedUsage/detail",
    component: () =>
      import("@/components/page/RMC/Produce/rmcProDrugDosage/detail"),
    meta: { title: "药品用量详情" },
  },
];
